import { extractRawAudio } from '../libs/mp4.js/audio';

export default class Mp4Audio {
    static extractRawAudioFromMp4ArrayBuffer = (arrayBuffer: ArrayBuffer): ArrayBuffer => {
        const uint8array = new Uint8Array(arrayBuffer);
        const rawAudio = extractRawAudio(uint8array);
        return rawAudio.data.buffer;
    }
}